import type { IconSvgObject } from './types';

const Png01Icon: IconSvgObject = [
  ["path", { d: "M4 12.9978L4.01994 3.99557C4.02238 2.89187 4.91845 1.99878 6.02216 2L12.9958 2.00776L20 8.99481L19.9922 12.9978M13 2.49778V6.99778C13 8.10235 13.8954 8.99778 15 8.99778H19.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M4 22V19M4 19V16H6C6.82843 16 7.5 16.6716 7.5 17.5C7.5 18.3284 6.82843 19 6 19H4ZM20 17V16H16.5V22H20V19.5H19M10 22V16L14 22V16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Png01Icon;
